import {
  GET_BRANCH_RESPONSE,
  ADD_BRANCH_DATA_REQUEST,
  ADD_BRANCH_RESPONSE,
  GET_ADDRESS_FROM_COORDS_RESPONSE,
  GET_BRANCH_SERVICES_RESPONSE,
  GET_BRANCHES_RESPONSE,
  GET_REQUEST_STATUS,
  GET_BRANCH_REVIEWS_RESPONSE,
  BRANCH_REVIEW_REQUEST_STATUS,
  GET_BRANCH_REVIEW_DETAILS_RESPONSE,
  GET_PUBLISH_BRANCH_SERVICE_REQUEST_STATUS,
  GET_DELETE_BRANCH_SPECIALITY_REQUEST_STATUS,
  GET_DELETE_BRANCH_SERVICE_REQUEST_STATUS
} from './types';

const INITIAL_STATE = {
  list: [],
  meta: {},
  branchDetails: {},
  addressFromCoords: {},
  addedBranch: {},
  savedBranchData: {},
  branchServices: {},
  branchCreatedId: null,
  requestStatus: null,
  branchReviews: {
    list: [],
    meta: {},
    reviewDetails: {},
    branchReviewRequestStatus: null,
  },
  publishBranchServiceStatusRequest:null,
  deleteBranchServiceStatusRequest:null,
  deleteBranchSpecialityStatusRequest: null,
};

const branches = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_BRANCH_RESPONSE:
      return {
        ...state,
        branchDetails: action.payload.branchDetails,
      };
    case GET_BRANCH_SERVICES_RESPONSE:
      return {
        ...state,
        branchServices: action.payload.branch_services,
        // meta: action.payload.meta,
      };
    case GET_ADDRESS_FROM_COORDS_RESPONSE:
      return {
        ...state,
        addressFromCoords: action.payload,
      };
    case ADD_BRANCH_RESPONSE:
      return {
        ...state,
        // addedBranch: action.payload,
        branchCreatedId: action.payload.id,
      };
    case ADD_BRANCH_DATA_REQUEST:
      return {
        ...state,
        savedBranchData: action.payload,
      };
    case GET_BRANCHES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_REQUEST_STATUS:
      return {
        ...state,
        requestStatus: action.payload === null ? null : action.payload,
      };
    case GET_BRANCH_REVIEWS_RESPONSE:
      return {
        ...state,
        branchReviews: {
          ...state.branchReviews,
          list: action.payload.list,
          meta: action.payload.meta,
        },
      };
    case BRANCH_REVIEW_REQUEST_STATUS:
      return {
        ...state,
        branchReviews: {
          ...state.branchReviews,
          branchReviewRequestStatus: action.payload === null ? null : action.payload,
        },
      };
    case GET_BRANCH_REVIEW_DETAILS_RESPONSE:
      return {
        ...state,
        branchReviews: {
          ...state.branchReviews,
          reviewDetails: action.payload,
        },
      };
    case GET_PUBLISH_BRANCH_SERVICE_REQUEST_STATUS:
      return {
        ...state,
        publishBranchServiceStatusRequest: action.payload === null ? null : action.payload,
      };
    case GET_DELETE_BRANCH_SERVICE_REQUEST_STATUS:
      return {
        ...state,
        deleteBranchServiceStatusRequest: action.payload === null ? null : action.payload,
      };
    case GET_DELETE_BRANCH_SPECIALITY_REQUEST_STATUS:
      return {
        ...state,
        deleteBranchSpecialityStatusRequest: action.payload === null ? null : action.payload,
      };
    default:
      return state;
  }
};

export default branches;
